import Modal from '../../ui/Modal/Modal';
import Icon from '../../ui/Icon/Icon';
import styles from './ExportTypesModal.module.css';

const BASE_TYPES = [
  { key: 'rawtext',    label: 'Raw text',    icon: 'FileText', desc: 'Plain PDF with chapter index',      ready: true },
  { key: 'ebook',      label: 'eBook',       icon: 'BookOpen', desc: 'EPUB-style chapters',               ready: false },
];

const SCREENPLAY_TYPES = [
  { key: 'rawdraft',   label: 'Draft',         icon: 'FileText', desc: 'PDF Draft of screenplay',                   ready: true },
  { key: 'decoupage',  label: 'Decoupage CSV', icon: 'Table',    desc: 'Scenes / locations / characters report',    ready: true },
];

// Lets the user pick an export target. Screenplay codices get the extra
// "decoupage" CSV report (scaletta only — plain is a single chapter with
// no per-scene rows) and skip ebook (not screenplay-compatible).
// While `loading` is true the modal swaps to a centered "preparing..." view
// and ignores close attempts so the user can't dismiss an in-flight export.
export default function ExportTypesModal({ isOpen, onClose, onSelect, codexType, codexSubtype, loading = false }) {
  let types;
  if (codexType === 'screenplay') {
    types = SCREENPLAY_TYPES.filter(
      (t) => !(t.key === 'decoupage' && codexSubtype === 'plain'),
    );
  } else {
    types = BASE_TYPES;
  }
  const handleClose = loading ? () => {} : onClose;
  return (
    <Modal isOpen={isOpen} onClose={handleClose} title="Export">
      {loading ? (
        <div className={styles.loading} role="status" aria-live="polite">
          <span className={styles.spinner} aria-hidden="true" />
          <span className={styles.loadingLabel}>Preparing your document...</span>
          <span className={styles.loadingHint}>This may take a moment</span>
        </div>
      ) : (
        <div className={styles.grid}>
          {types.map((t) => (
            <button
              key={t.key}
              type="button"
              className={`${styles.card} ${t.ready ? '' : styles.disabled}`}
              disabled={!t.ready}
              onClick={() => t.ready && onSelect(t.key)}
            >
              <span className={styles.icon}>
                <Icon
                  name={t.icon}
                  size={22}
                  tone={t.ready ? 'accent' : 'dim'}
                />
              </span>
              <span className={styles.label}>{t.label}</span>
              <span className={styles.desc}>{t.desc}</span>
              {!t.ready && <span className={styles.soon}>soon</span>}
            </button>
          ))}
        </div>
      )}
    </Modal>
  );
}
